import { assertFinancialPresentation } from './quoteFinancialPresentation';
import { documentTerms } from './quoteTermsSnapshot';

export const quoteDocumentReadiness = ({ editor, calculated, calculationStatus, documentType = 'client_quote', pendingComposition = false } = {}) => {
  if (!editor) return { ready: false, message: 'Ouvrez un devis avant de produire un document.' };
  if (pendingComposition || editor.pendingComposition) return { ready: false, message: 'Enregistrez les saisies de composition avant de produire un document.' };
  if (editor.contentSchemaVersion === 2) return { ready: editor.composition?.state === 'complete' && editor.serverCalculationStatus !== 'stale',
    message: editor.composition?.state === 'complete' && editor.serverCalculationStatus !== 'stale' ? null : 'Enregistrez les informations et complétez les ensembles avant de produire un document.' };
  if ((editor.currencyCode ?? 'EUR') !== 'EUR') return { ready: false, message: 'Nouvelle génération indisponible pour cette devise historique. Consultez les fichiers existants.' };
  if (['stale', 'calculating', 'idle'].includes(calculationStatus)) {
    return { ready: false, message: 'Le calcul est en cours ou à actualiser. Attendez son résultat avant de produire un document.' };
  }
  if (calculationStatus === 'error') return { ready: false, message: 'Corrigez l’erreur de calcul avant de produire un document.' };
  if (editor.permissions?.canViewCosts === false && editor.serverCalculationStatus === 'stale') {
    return { ready: false, message: 'Enregistrez les modifications pour obtenir les montants confirmés avant de produire un document.' };
  }
  try {
    assertFinancialPresentation(calculated, editor.versionStatus && editor.versionStatus !== 'draft' ? editor.serverCalculation?.totals : null);
    if (documentType === 'client_quote' && editor.versionStatus && !['draft', 'validated'].includes(editor.versionStatus)) {
      documentTerms({ status: editor.versionStatus, clientDocument: editor.clientDocument });
    }
    return { ready: true, message: null };
  } catch (error) {
    if (error.code === 'QUOTE_DOCUMENT_TERMS_UNAVAILABLE') return { ready: false, message: error.message };
    return { ready: false, message: `${error.message} Rechargez ou enregistrez la version avant de produire un document.` };
  }
};

export const assertQuoteDocumentReady = (context) => {
  const result = quoteDocumentReadiness(context);
  if (!result.ready) throw Object.assign(new Error(result.message), { code: 'QUOTE_DOCUMENT_NOT_READY' });
};
